module.exports = __webpack_public_path__ + "img/brand-10.674e2187.png";